const formatToBrCurrency = require('../helpers/formatToBrCurrency');
const Lang = require('lang');

$.jMaskGlobals.dataMask = false;

function inputMasks() {
  const SPMaskBehavior = function (val) {
    const tamanhoMascara = val.replace(/\D/g, '').length;
    switch (tamanhoMascara) {
      case 11:
        return '(00) 00000-00009';
      case 12:
        return '+(0)(00) 00000-00009';
      case 13:
        return '+(00)(00) 00000-00009';
      case 14:
        return '+(000)(00) 00000-0000';
      default:
        return '(00) 0000-00009';
    }
  };
  const spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
  };

  $.datepicker.setDefaults({
    showButtonPanel: true,
    dateFormat: 'dd/mm/yy',
    currentText: Lang.get('js/src/helpers/inputMasks.today'),
    dayNames: [Lang.get('js/src/helpers/inputMasks.sunday'), Lang.get('js/src/helpers/inputMasks.monday'), Lang.get('js/src/helpers/inputMasks.tueday'), Lang.get('js/src/helpers/inputMasks.wednesday'), Lang.get('js/src/helpers/inputMasks.thursday'), Lang.get('js/src/helpers/inputMasks.friday'), Lang.get('js/src/helpers/inputMasks.saturday')],
    dayNamesMin: [Lang.get('js/src/helpers/inputMasks.sunday_word'), Lang.get('js/src/helpers/inputMasks.monday_word'), Lang.get('js/src/helpers/inputMasks.tueday_word'), Lang.get('js/src/helpers/inputMasks.wednesday_word'), Lang.get('js/src/helpers/inputMasks.thursday_word'), Lang.get('js/src/helpers/inputMasks.friday_word'), Lang.get('js/src/helpers/inputMasks.saturday_word'), Lang.get('js/src/helpers/inputMasks.sunday_word_2')],
    dayNamesShort: [Lang.get('js/src/helpers/inputMasks.sunday_abbreviation'), Lang.get('js/src/helpers/inputMasks.monday_abbreviation'), Lang.get('js/src/helpers/inputMasks.tueday_abbreviation'), Lang.get('js/src/helpers/inputMasks.wednesday_abbreviation'), Lang.get('js/src/helpers/inputMasks.thursday_abbreviation'), Lang.get('js/src/helpers/inputMasks.friday_abbreviation'), Lang.get('js/src/helpers/inputMasks.saturday_abbreviation'), Lang.get('js/src/helpers/inputMasks.sunday_abbreviation_2')],
    monthNames: [Lang.get('js/src/helpers/inputMasks.january'), Lang.get('js/src/helpers/inputMasks.february'), Lang.get('js/src/helpers/inputMasks.march'), Lang.get('js/src/helpers/inputMasks.april'), Lang.get('js/src/helpers/inputMasks.may'), Lang.get('js/src/helpers/inputMasks.june'), Lang.get('js/src/helpers/inputMasks.july'), Lang.get('js/src/helpers/inputMasks.august'), Lang.get('js/src/helpers/inputMasks.september'), Lang.get('js/src/helpers/inputMasks.october'), Lang.get('js/src/helpers/inputMasks.november'), Lang.get('js/src/helpers/inputMasks.december')],
    monthNamesShort: [Lang.get('js/src/helpers/inputMasks.january_abbreviation'), Lang.get('js/src/helpers/inputMasks.february_abbreviation'), Lang.get('js/src/helpers/inputMasks.march_abbreviation'), Lang.get('js/src/helpers/inputMasks.april_abbreviation'), Lang.get('js/src/helpers/inputMasks.may_abbreviation'), Lang.get('js/src/helpers/inputMasks.june_abbreviation'), Lang.get('js/src/helpers/inputMasks.july_abbreviation'), Lang.get('js/src/helpers/inputMasks.august_abbreviation'), Lang.get('js/src/helpers/inputMasks.september_abbreviation'), Lang.get('js/src/helpers/inputMasks.october_abbreviation'), Lang.get('js/src/helpers/inputMasks.november_abbreviation'), Lang.get('js/src/helpers/inputMasks.december_abbreviation')],
    nextText: Lang.get('js/src/helpers/inputMasks.next'),
    prevText: Lang.get('js/src/helpers/inputMasks.previous'),
    closeText: Lang.get('js/src/helpers/inputMasks.exit'),
  });


  const datePickers = $('[data-input^="date"]');

  datePickers.each(function (n, el) {
    const format = $.timepicker.regional[Lang.getLocale()];
    const formatExtended = {
      timeFormat: 'HH:mm:ss',
      showHour: true,
      showMinute: true,
      showSecond: true
    };

    // Merge objects taking the second args properties over the first arg
    jQuery.extend(format, formatExtended);

    let options = null;
    if (el.dataset.format === 'month') {
      options = {
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        dateFormat: 'yy/mm',
        closeText: Lang.get('js/src/helpers/inputMasks.done'),
        onClose: function (dateText, inst) {
          $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
        }
      };
    }

    const $el = el.dataset.input == 'date'
      ? $(el).datepicker(options)
      : $(el).datetimepicker(format);

    el.setAttribute('readonly', true);

    el.addEventListener('click', function (e) {
      e.target.focus();
    });

    $el.on('change', function () {
      try {
        $(this).valid();
      } catch (e) {

      }
    });

    el.addEventListener('blur', function (e) {
      const picker = document.getElementById('ui-datepicker-div');

      if (!picker.contains(e.relatedTarget) && e.relatedTarget) {
        $el.datepicker('hide');
      }

    });

    const keyDownHandler = function (e) {
      if (e.keyCode == 8 || e.keyCode == 46) {
        e.preventDefault();
        $.datepicker._clearDate(this);
      }
    };

    el.addEventListener('keydown', keyDownHandler);
    if (el.classList.contains('data-enable-after-date-time-mask')) {
      $(el).prop('disabled', false);
    }
  });

  $('[data-format^="month"]').on('focus', function () {
    $('.ui-datepicker-calendar').hide();
  });

  $('[name="dataNascimento"], [data-mask="date"]').mask('00/00/0000', {
    placeholder: '__/__/____'
  });

  $('[data-phone-mask="true"]').mask(SPMaskBehavior, spOptions);

  $('[data-only-phone-number-mask="true"]').mask('00000-0009');
  $('[data-ddd-mask="true"]').mask('09');

  $('[data-currency=true], [data-input="currency"], [data-mask="currency"]').each((index, input) => {

    if ($(input).val().trim() !== '' && !$(input).data('currencyDecimalPlaces')) {
      const str = (parseFloat($(input).val().replace(',', '.'))).toFixed(2);

      if (str !== 'NaN') {
        $(input).val(str);
      }
    }

    const acceptNegative = input.dataset.currencyNegative === 'true';
    const alwaysNegative = input.dataset.alwaysNegative === 'true';
    const decimalPlaces = input.dataset.currencyDecimalPlaces || 2;
    const decimalsMask = '0'.repeat(decimalPlaces);
    const mask = '#.##0,' + decimalsMask;

    if (alwaysNegative) {
      $(input).maskMoney({
        prefix: '- ',
        thousands: '.',
        decimal: ','
      });
      $(input).maskMoney('mask');
    } else {
      $(input).mask(mask, {
        reverse: true,
        translation: {
          '#': {
            pattern: acceptNegative ? /-|\d/ : /\d/,
            recursive: true
          },
          '0': {
            pattern: acceptNegative ? /-|\d/ : /\d/
          }
        },
        onChange: function (value, e) {
          e.target.value = value
            .replace(/^\.+/, '')
            .replace(/(?!^)-/g, '')
            .replace(/^(-[,.])/, '-')
            .replace(new RegExp('/(\d+\.*)\.(\d{' + decimalPlaces + '})$'), '$1,$2');
        }
      });
    }

    $('[data-enable-after-currency-mask]').prop('disabled', false);
  });

  $('[data-mask="currency-exchange"]').mask(
    '000.000.000.000.000,00000',
    { reverse: true }
  );

  $(document).on('focus', 'input[data-mask="currency-integer"]', function () {
    $('[data-mask="currency-integer"]').mask(
      '000.000.000',
      { reverse: true }
    );
  });

  $('[data-mask="integer"]').mask('0#');

  $('[name="cpf"],[data-mask="cpf"]').mask('000.000.000-00', {
    reverse: true
  });

  $('[name="cnpj"], [data-mask="cnpj"]').mask('99.999.999/9999-99');

  $('[name="cep"]:not(#cep_param)').mask('00000-000');

  $('[data-mask="credit-card"]').mask('0000 0000 0000 0000', { recursive: true });

  // permite apenas numeros inteiros (sem ponto/virgula)
  $('[data-int="true"]').mask('0#');

  // máscara que aceita apenas dois números decimais
  $('[data-mask="percentage"]').mask('000,00', { reverse: true });

  $(document).ready(function () {
    const inputCpfOrCnpj = $('#cpfOrCnpj');

    if (inputCpfOrCnpj.length > 0) {
      const inputValue = inputCpfOrCnpj[0].value.replaceAll(/[./-]/g, '');
      if (inputValue.length === 11) {
        inputCpfOrCnpj.mask('000.000.000-000000');
      } else {
        inputCpfOrCnpj.mask('00.000.000/0000-00');
      }

      inputCpfOrCnpj.on('keyup', function () {
        // value.length > 14 porque nesse ponto estamos contando com a máscara.
        if (inputCpfOrCnpj[0].value.length <= 14) {
          inputCpfOrCnpj.mask('000.000.000-000000');
        }
        else {
          inputCpfOrCnpj.mask('00.000.000/0000-00');
        }
      });
    }
  });

  $(document).on('change keyup', '[data-mask="rateio-currency"]', function (event) {
    $(event.target).mask('0.000.000.000,00', {
      reverse: true,
      translation: {
        '0': {
          pattern: /-|\d/
        }
      },
      onChange: function (value, e) {
        e.target.value = value
          .replace(/(?!^)-/g, '')
          .replace(/^,/, '')
          .replace(/^(-[,.])/, '-');
      }
    });

    event.target.value = event.target.value
      .replace(/(?!^)-/g, '')
      .replace(/^,/, '')
      .replace(/^(-[,.])/, '-');
  });
}

exports.init = inputMasks;
